/* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';
import { Text, Icon } from '@reservamos/elements';
import useWhitelabelCopies from 'hooks/whitelabel/useWhitelabelCopies';
import { CurrentLang } from 'utils/lang';

/**
 * WalletNotAvailable component.
 * Renders a message indicating that the wallet/loyalty program is not available for the current route.
 * @param {object} props - Component props.
 * @param {string} props.loyalty - Loyalty program name (costapass or travelpass).
 * @returns {JSX.Element} The rendered component.
 */
const WalletNotAvailable = ({ loyalty = 'costapass' }) => {
  const { t } = useTranslation('payment');
  const { policies } = useWhitelabelCopies();
  const currentLang = CurrentLang();

  const termsAndConditionsTravelpassUrl = policies?.[currentLang]?.termsAndConditionsTravelpassUrl;
  const hasWalletTermUrl = Boolean(termsAndConditionsTravelpassUrl);

  if (!hasWalletTermUrl) return null;

  return (
    <div className="wallet-not-available border-[1px] border-primary-regular rounded-[10px] p-4 bg-gray-50">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center self-stretch">
          <Icon type="Info" size="M" color="primary" />
        </div>
        <div className="flex-1">
          <Text size="M" weight="semibold" color="grayDark">
            {t('wallet_not_available_title')}
          </Text>
          <Text size="S" color="grayMedium" className="mt-1">
            <Trans
              i18nKey="payment:wallet_not_available_description"
              components={{
                routesLink: (
                  <a
                    href={termsAndConditionsTravelpassUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary-regular underline hover:text-primary-strong"
                  />
                ),
              }}
            />
          </Text>
        </div>
        <i className={`slider-logo ${loyalty}-logo`} />
      </div>
    </div>
  );
};

WalletNotAvailable.propTypes = {
  loyalty: PropTypes.string,
};

export default WalletNotAvailable;
